import { toFirstLetterUpperCase } from '../../utils/common';

export const insights = () => ({
  onInsightPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/where-is-your-money-invested',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Where is Your Money Invested',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Where is Your Money Invested',
    // });
  },
  onClickWhereIsYourMoneyInvested: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/where-is-your-money-invested',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Where is Your Money Invested',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Where is Your Money Invested',
    // });
  },
  onClickFundHouseWiseAllocation: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/fund-house-wise-allocation',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Fund House wise Allocation',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Fund House wise Allocation',
    // });
  },
  onClickOfInvestMoreOfFundHouseWiseAllocation: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Fund House wise Allocation - ' + schemeName + ' - Invest More',
    // });
  },
  onClickOfExploreMoreOfFundHouseWiseAllocation: (amcName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Fund House wise Allocation - ' + amcName + ' - Explore More',
    // });
  },
  onClickFundCategoryWiseAllocation: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/fund-category-wise-allocation',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Fund Category wise Allocation',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Fund Category wise Allocation',
    // });
  },
  onClickOfExploreMoreInFundCategoryWiseAllocation: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Fund Category wise Allocation - Explore More',
    // });
  },
  onClickViewAllInFundCategoryWiseAllocation: (categoryName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label:
    //     'Portfolio - Insights - Fund Category wise Allocation - ' +
    //     toFirstLetterUpperCase(categoryName) +
    //     ' - View All',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page:
    //     'vpv/pfm/online-investments/portfolio/insights/fund-category-wise-allocation/' +
    //     categoryName?.toLowerCase() +
    //     '-listings',
    //   title:
    //     'PFM - Online Investments - Portfolio - Insights - Fund Category wise Allocation - ' +
    //     toFirstLetterUpperCase(categoryName) +
    //     ' Listings',
    // });
  },
  onClickInvestMoreInFundCategoryWiseAllocation: (schemeName: string, categoryName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label:
    //     'Portfolio - Insights - Fund Category wise Allocation - ' +
    //     toFirstLetterUpperCase(categoryName) +
    //     ' - View All - ' +
    //     toFirstLetterUpperCase(categoryName) +
    //     ' Listing -' +
    //     schemeName +
    //     ' - Invest More',
    // });
  },
  onCloseFundCategoryModal: (categoryName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label:
    //     'Portfolio - Insights - Fund Category wise Allocation  - ' +
    //     toFirstLetterUpperCase(categoryName) +
    //     ' - View All - ' +
    //     toFirstLetterUpperCase(categoryName) +
    //     ' Listing - Close',
    // });
  },
  onClickOfFundReturns: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/fund-returns',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Fund Returns',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Fund Returns',
    // });
  },
  onClickOfViewMyHoldingsInFundReturns: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Fund Returns - View My Holdings',
    // });
  },
  onClickRatingWiseAllocation: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/rating-wise-allocation-for-debt-schemes',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Rating Wise Allocation For Debt Schemes',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Rating Wise Allocation For Debt Schemes',
    // });
  },
  onClickSectorWiseAllocation: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/sector-wise-allocation',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Sector Wise Allocation',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Sector Wise Allocation',
    // });
  },
  onClickSystematicTransaction: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/systematic-transactions',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Systematic Transactions',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Systematic Transactions',
    // });
  },
  onClickViewAllOfSystematicTransaction: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Systematic Transactions - View All',
    // });
  },
  onClickOfSchemeRiskProfileAnalysis: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/scheme-risk-profile-analysis',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Scheme Risk Profile Analysis',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Scheme Risk Profile Analysis',
    // });
  },
  onClickAxisBankSelectFundCategory: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/insights/axis-bank-select-fund-category',
    //   title: 'PFM - Online Investments - Portfolio - Insights - Axis Bank Select Fund Category',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Axis Bank Select Fund Category',
    // });
  },
  onClickExploreMoreAxisBankSelectFundCategory: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Axis Bank Select Fund Category - Explore More',
    // });
  },
  onClickInvestMoreAxisBankSelectFundCategory: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Axis Bank Select Fund Category - ' + schemeName + ' - Invest More',
    // });
  },
  onClickBackButton: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Insights - Back',
    // });
  },
});
